import React from 'react';
import { SkeletonGroup, SkeletonLine, TableToolbar } from '@wix/design-system';

interface CollectionToolbarSkeletonItemProps {
  dataHook: string;
  width: string;
}

export function CollectionToolbarSkeletonItem(
  props: CollectionToolbarSkeletonItemProps,
) {
  const { dataHook, width } = props;

  return (
    <TableToolbar.ItemGroup dataHook={dataHook} position="start">
      <SkeletonGroup>
        <SkeletonLine width={width} />
      </SkeletonGroup>
    </TableToolbar.ItemGroup>
  );
}
